module.exports = __webpack_public_path__ + "static/media/dashboard-icon-statements.94cb2a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard-icon-statements.svg
// module id = 745
// module chunks = 0